import React, { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

import { images } from "../../constants";
import { HiMenuAlt4, HiX } from "react-icons/hi";
import { motion } from "framer-motion";

import "./Navbar.scss";

const Navbar = () => {
  const rootPageWithLocationHashes = [
    "/#home",
    "/#about",
    "/#work",
    "/#skills",
    "/#testimonial",
    "/#process",
    "/#contact",
  ];

  const samePageLocationHashes = [
    "#home",
    "#about",
    "#work",
    "#skills",
    "#testimonial",
    "#process",
    "#contact",
  ];

  const getNavItems = () => {
    if (location.pathname.includes("project"))
      return rootPageWithLocationHashes;
    return samePageLocationHashes;
  };

  const [toggle, setToggle] = useState<boolean>(false);
  const location = useLocation();

  return (
    <nav className="app__navbar">
      <div className="app__navbar-logo">
        {/* <img src={images.ap} alt="logo" /> */}
        <Link to="/">
          <img src={images.ap} alt="logo" />
        </Link>
      </div>
      <ul className="app__navbar-links">
        {getNavItems().map((item) => (
          <li className="app__flex p-text" key={`link-${item}`}>
            <div />
            <HashLink to={`${item}`}>
              {item.substring(item.indexOf("#") + 1)}
            </HashLink>
          </li>
        ))}
      </ul>
      <div className="app__navbar-menu">
        <HiMenuAlt4 onClick={() => setToggle(true)} />
        {toggle && (
          <>
            <motion.div
              whileInView={{ x: [300, 0] }}
              transition={{ duration: 0.85, ease: "easeOut" }}
            >
              <ul>
                {getNavItems().map((item) => (
                  <li key={item} onClick={() => setToggle(false)}>
                    <HashLink to={`${item}`}>
                      {item.substring(item.indexOf("#") + 1)}
                    </HashLink>
                  </li>
                ))}
              </ul>
              <HiX onClick={() => setToggle(false)} />
            </motion.div>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
